const REGION_WW = 1;

//Upload safety limits: raw photos taken with recent phones can be very heavy, and a request that
//exceeds what the server accepts fails without any readable response (see axios interceptor).
//Those values must stay below the PHP settings of the server (external prod: upload_max_filesize
//128M, post_max_size 256M). The total is mostly there to keep the upload duration reasonable on a
//store connection: all the photos of a survey are sent in a single request.
const MAX_UPLOAD_FILE_SIZE_MB = 30;
const MAX_UPLOAD_TOTAL_SIZE_MB = 50;

export {REGION_WW, MAX_UPLOAD_FILE_SIZE_MB, MAX_UPLOAD_TOTAL_SIZE_MB};
